import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import LeadHead from "./LeadHead"
import LeadBody from "./LeadBody"

LeadTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listLead: PropTypes.array
}

function LeadTable(props) {
    const {loading, error, listLead} = props

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu">
                <table>
                    <LeadHead/>
                    <LeadBody
                        {...props}
                        loading={loading}
                        error={error}
                        listLead={listLead}
                    />
                </table>
            </Spin>
        </div>
    )
}

export default LeadTable